import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { Toolbar, AppBar, Hidden, IconButton, Icon, Tooltip, Dialog, DialogContent, DialogTitle, Box, Typography, Button } from '@material-ui/core';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import { selectToolbarTheme } from 'app/store/fuse/settingsSlice';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
import LicenseNotificationBar from '../../shared-components/LicenseNotificationBar';
import LicenseType from '../../shared-components/LicenseType';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
    root: {}
}));

function ToolbarLayout1(props) {
    const dispatch = useDispatch();
    const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
    const user = useSelector(({ auth }) => auth.user);
    const isLoggedIn = useSelector(({ auth }) => auth.user.isLoggedIn);
    const userLicense = useSelector(({ auth }) => auth.user.userLicense);
    const [showNotificationToolbar, setShowNotificationToolbar] = useState(true);
    const toolbarTheme = useSelector(selectToolbarTheme);
    const { t } = useTranslation('fuse-layout');
    const classes = useStyles(props);
    const header = useSelector(({ fuse }) => fuse.header);
    const redirectPath = () => {
        let path = window.location.pathname;
        if (path.startsWith('/free')) path = path.substring('/free'.length);
        return path;
    }

    useEffect(() => {
        let hideNotification = sessionStorage.getItem('hide-license-notification-bar')
        if (hideNotification && hideNotification == 'true') {
            setShowNotificationToolbar(false)
        } else {
            setShowNotificationToolbar(true)
        }
    }, [dispatch]);


    return (<>
        <ThemeProvider theme={toolbarTheme}>
            <AppBar
                id="fuse-toolbar"
                className={clsx(classes.root, 'flex relative z-10 shadow-md')}
                color="primary"
            // style={{ backgroundColor: toolbarTheme.palette.background.paper }}
            >
                {isLoggedIn && !user.license && showNotificationToolbar && (<LicenseNotificationBar closeNotificationToolbar={() => setShowNotificationToolbar(false)} />)}

                <Toolbar className="p-0 min-h-48">
                    {config.navbar.display && (
                        <Hidden lgUp>
                            <NavbarMobileToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
                        </Hidden>
                    )}

                    <div className="xs:text-20 sm:text-24 m-16 text-white font-bold">{header && header.title}</div>

                    <div className="flex flex-1">
                    </div>
                    <div className="flex items-center px-16 text-white">
                        {user.isLoggedIn && <LicenseType />}
                        <LanguageSwitcher />
                        <FullScreenToggle />
                        |
                        {!user.isLoggedIn &&
                            <Tooltip title={t('toolbar.login')} placement="bottom">
                                <IconButton
                                    aria-label="login"
                                    className={clsx('w-40 h-40 text-white', props.className)}
                                    to={() => "/auth/login?redirect=" + redirectPath()}
                                    component={Link}>
                                    <Icon>login</Icon>
                                </IconButton>
                            </Tooltip>
                        }
                        {!user.isLoggedIn &&
                            <Tooltip title={t('toolbar.register')} placement="bottom">
                                <IconButton aria-label="Register" className={clsx('w-40 h-40 text-white', props.className)} to="/auth/register" component={Link}>
                                    <Icon>person_add</Icon>
                                </IconButton>
                            </Tooltip>
                        }
                        {user.isLoggedIn && <UserMenu />}
                    </div>
                </Toolbar>
            </AppBar>
        </ThemeProvider>
    </>
    );
}

export default React.memo(ToolbarLayout1);
